import Smarquee from 'smarquee';
import merge from 'lodash-es/merge';
import defer from 'lodash-es/defer';
import get from 'lodash-es/get';
import pick from 'lodash-es/pick';
import omit from 'lodash-es/omit';
import find from 'lodash-es/find';
import each from 'lodash-es/each';
import kebabCase from 'lodash-es/kebabCase';
import isEmpty from 'lodash-es/isEmpty';
import isString from 'lodash-es/isString';
import isObject from 'lodash-es/isObject';

import getDefaultStyle from '../css/defaultStyle';
import updateStyle from '../css/updateStyle';
import updateClass from '../css/updateClass';
import uniqueId from '../uniqueId';

import { getDefaultTickerStyle, getDefaultTicker } from './ticker.defaults';

import Control from './control';

export default class Ticker extends Control {
  constructor(instance, path) {
    super(instance, path);
    this._ignoreData = true;
  }

  renderElement(data) {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;

    if (!control.el) {
      control.el = getDefaultTicker();
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-ticker-', Ticker);
        control.mIndex = 1;
        control.styleSheet = 'css-' + control.id;        
      }else{
        control.el.setAttribute('id',control.id);
      }
      // instance.on('update', function(evt, opts) {
      //   defer(function() {
      //     // console.log('ticker update');
      //     control.render(get(opts, path).data);
      //   });
      // });
    }

    data = data || options.data || [];
    if (!data.length) {
      return control.el;
    }

    var bodyEl = control.el.getElementsByClassName('body')[0];
    var marqueeEl = bodyEl.getElementsByClassName('marquee');
    var mi = control.mIndex ? 0 : 1;
    var defaultStyle = getDefaultTickerStyle();
    var stylePatch = {};
    var bodyStylePatch = {};
    var marqueeStylePatches = [{}, {}];

    merge(stylePatch, defaultStyle.normal);
    merge(bodyStylePatch, defaultStyle.body.normal);
    merge(marqueeStylePatches, [defaultStyle.marquee.normal, defaultStyle.marquee.normal]);
    merge(marqueeStylePatches[1], defaultStyle.marquee.second);
    merge(marqueeStylePatches[control.mIndex], defaultStyle.marquee.hidden);

    if (options.style && options.style.normal) {
      merge(
        stylePatch,
        pick(options.style.normal, ['bottom', 'height', 'left', 'right', 'top', 'width'])
      );
      merge(
        bodyStylePatch,
        omit(options.style.normal, ['bottom', 'height', 'left', 'right', 'top', 'width'])
      );
    }

    if (options.crossfade) {
      marqueeStylePatches[0].transitionDuration = options.crossfade;
      marqueeStylePatches[1].transitionDuration = options.crossfade;
    }

    updateStyle(control.el, stylePatch, control.currentStyle);
    control.currentStyle = stylePatch;

    updateStyle(bodyEl, bodyStylePatch, control.currentBodyStyle);
    control.currentBodyStyle = bodyStylePatch;

    updateStyle(
      marqueeEl[0],
      marqueeStylePatches[0],
      control.currentMarqueeStyle && control.currentMarqueeStyle[0]
    );
    updateStyle(
      marqueeEl[1],
      marqueeStylePatches[1],
      control.currentMarqueeStyle && control.currentMarqueeStyle[1]
    );
    control.currentMarqueeStyle = marqueeStylePatches;

    var CSS = [
      {
        selector: '.item',
        properties: merge(
          {},
          defaultStyle.item.normal,
          (options.item && options.item.style && options.item.style.normal) || {}
        ),
      },
      {
        selector: '.body:hover .item',
        properties: merge(
          {},
          defaultStyle.item.hover,
          (options.item && options.item.style && options.item.style.hover) || {}
        ),
      },
      {
        selector: '.item .label',
        properties: merge(
          {},
          defaultStyle.label.normal,
          (options.item &&
            options.item.label &&
            options.item.label.style &&
            options.item.label.style.normal) ||
            {}
        ),
      },
      {
        selector: '.body:hover .item .label',
        properties: merge(
          {},
          defaultStyle.label.hover,
          (options.item &&
            options.item.label &&
            options.item.label.style &&
            options.item.label.style.normal) ||
            {}
        ),
      },
      {
        selector: '.item .icon',
        properties: merge(
          {},
          defaultStyle.icon.normal,
          (options.item &&
            options.item.icon &&
            options.item.icon.style &&
            options.item.icon.style.normal) ||
            {}
        ),
      },
      {
        selector: '.body:hover .item .icon',
        properties: merge(
          {},
          defaultStyle.icon.hover,
          (options.item &&
            options.item.icon &&
            options.item.icon.style &&
            options.item.icon.style.normal) ||
            {}
        ),
      },
    ];
    if (options.item && options.item.icon) {
      var rule = find(CSS, ['selector', '.item .icon']);
      if (options.item.icon.url) {
        rule.properties.backgroundImage = 'url("' + options.item.icon.url + '")';
      }

      if (options.item.icon.width) {
        rule.properties.width = options.item.icon.width;
      }

      if (options.item.icon.height) {
        rule.properties.height = options.item.icon.height;
      }

      if (options.item.icon.scale) {
        rule.properties.backgroundSize = options.item.icon.scale;
      }

      if (options.item.icon.position) {
        rule.properties.backgroundPosition = options.item.icon.position;
      }
    }

    var icons = options.icons || defaultStyle.icons;
    each(icons, function(i) {
      var rule = {
        selector: '.item .icon.' + kebabCase(i.name),
        properties: merge({}, (i.style && i.style.normal) || {}),
      };
      if (i.url) {
        rule.properties.backgroundImage = 'url("' + i.url + '")';
      }

      if (i.width) {
        rule.properties.width = i.width;
      }

      if (i.height) {
        rule.properties.height = i.height;
      }

      if (i.scale) {
        rule.properties.backgroundSize = i.scale;
      }

      if (i.position) {
        rule.properties.backgroundPosition = i.position;
      }

      if (!isEmpty(rule.properties)) {
        CSS.push(rule);
      }

      rule = {
        selector: '.body:hover .item .icon.' + kebabCase(i.name),
        properties: merge({}, (i.style && i.style.hover) || {}),
      };
      if (!isEmpty(rule.properties)) {
        CSS.push(rule);
      }
    });
    control.styleSheet = updateClass(control.styleSheet, CSS, '#' + control.id);

    data = data || options.data || [];
    var labelAlign = (options.item && options.item.label && options.item.label.align) || 'left';
    // console.log('render ticker data',data);
    var itemEls = document.createDocumentFragment();
    each(data, function(d) {
      // var icon = (isString(d.icon)?find(icons,['name',d.icon]):d.icon)||null;
      var itemEl = document.createElement('div');
      itemEl.classList.add('item');
      if (d.icon && d.icon.visible !== false) {
        var icon = d.icon;
        var iconEl = document.createElement('i');
        iconEl.classList.add('icon');
        // iconEl.setAttribute('src',icon.url);
        var iconClass = isString(icon) ? icon : icon.name;
        if (iconClass) {
          iconEl.classList.add(kebabCase(iconClass));
        }

        if (isObject(icon)) {
          var iconStylePatch = {};
          if (icon.style && icon.style.normal) {
            merge(iconStylePatch, icon.style.normal);
          }

          if (icon.width) {
            iconStylePatch.width = icon.width;
          }

          if (icon.height) {
            iconStylePatch.height = icon.height;
          }

          if (icon.url) {
            iconStylePatch.backgroundImage = 'url("' + icon.url + '")';
          }

          if (!isEmpty(iconStylePatch)) {
            updateStyle(iconEl, iconStylePatch);
          }
        }
      }

      if (d.label && d.label.visible !== false) {
        var labelEl = document.createElement('span');
        labelEl.classList.add('label');
        labelEl.innerHTML = d.label.text;
        if (d.label.style && d.label.style.normal) {
          updateStyle(labelEl, d.label.style.normal);
        }
      }

      if (labelAlign == 'left') {
        if (labelEl) {
          itemEl.appendChild(labelEl);
        }

        if (iconEl) {
          itemEl.appendChild(iconEl);
        }
      } else {
        if (iconEl) {
          itemEl.appendChild(iconEl);
        }

        if (labelEl) {
          itemEl.appendChild(labelEl);
        }
      }

      itemEls.appendChild(itemEl);
    });
    defer(function() {
      let oldSmarquee = control.oldSmarquee;
      if (oldSmarquee) {
        oldSmarquee.destroy();
      }

      marqueeEl[mi].innerHTML = '';
      marqueeEl[mi].appendChild(itemEls);
      control.oldSmarquee = control.smarquee;
      let delta = control.start ? Date.now() - control.start : 0;
      if (!control.start) {
        control.start = Date.now();
      }

      control.smarquee = new Smarquee({
        element: marqueeEl[mi],
        velocity: options.velocity || 50,
        styleOptions: { delay: -delta + 'ms', pausePercent: 0 },
      });
      control.smarquee.init();

      control.mIndex = mi;
    });
    return control.el;
  }
}
